import { GenericBaseParameter } from "../../models/base-parameter";
import { IPropertyParameterModel } from "../../models/property";
import { PersonSmartSearchParameterModel } from "../../models/person";
import { IDemandParameterModel } from "../../models/demand";
import { TaskParameterModel } from "../../models/task";

export interface IFilterWrapperState {
    propertySearchParam?: GenericBaseParameter<IPropertyParameterModel>,
    personSearchParam?: GenericBaseParameter<PersonSmartSearchParameterModel>,
    demandSearchParam?: GenericBaseParameter<IDemandParameterModel>,
    taskSearchParam?: GenericBaseParameter<TaskParameterModel>
}

export class FilterWrapperState implements IFilterWrapperState {
    propertySearchParam?: GenericBaseParameter<IPropertyParameterModel>;
    personSearchParam?: GenericBaseParameter<PersonSmartSearchParameterModel>;
    demandSearchParam?: GenericBaseParameter<IDemandParameterModel>;
    taskSearchParam?: GenericBaseParameter<TaskParameterModel>;
    constructor() {
        this.propertySearchParam = null;
        this.personSearchParam = null;
        this.demandSearchParam = null;
        this.taskSearchParam = null;
    }
}